import MapProperties from './models/map/Properties';
import GovernanceData from './models/data/governance';
import AirSource from './models/source/air/index';
import AirQualityData from './models/data/airQuality/index';
import SchoolData from './models/data/schoolData/index';
import GovernanceSource from './models/source/governance/index';
import JGRICMYCSource from './models/source/jgrIcmyc/index'
import ViewSettings from './models/settings/index';
import CivicSource from './models/source/civic';

const initialState = {
  thingSpeak: {
    sources: new Map(),
    loading: false,
    loaded: false
  },
  openAQ: {
    source: new AirSource()
  },
  map: new MapProperties(),
  governanceData: new GovernanceData(),
  airQuality: new AirQualityData(),
  schoolData: new SchoolData(),
  gov: new GovernanceSource(),
  jgrIcmyc: new JGRICMYCSource(),
  civic: new CivicSource(),
  viewSettings: new ViewSettings({
    air: false,
    waste: false,
    water: false,
    sanitation: false,
    governance: true,
    pothole: false,
    civic: false
  }),
};

export default initialState;



// WEBPACK FOOTER //
// ./src/initialState.js